import loginType from "../../actions/login/loginType";

const initialState = {
  error: false,
  errorMessage: "",
  errorType: "",
  loading: false,
  activeStep: 0,
  isLogin: false,
  typeLogin: 0,
  username: "",
};
const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case loginType.START_LOGIN:
      return {
        ...state,
        error: false,
        errorMessage: "",
        errorType: "",
        loading: true,
      };
    case loginType.START_REGISTER:
      return {
        ...state,
        activeStep: action.payload,
        error: false,
        errorMessage: "",
        errorType: "",
        loading: true,
        username: action.username ? action.username : state.username,
      };
    case loginType.FAILURE_LOGIN:
      return {
        ...state,
        error: true,
        errorMessage: action.errorMessage,
        errorType: action.errorType,
        loading: false,
      };
    case loginType.SET_ERROR_FALSE:
      return {
        ...state,
        error: false,
        errorMessage: "",
        errorType: "",
      };
    case loginType.CHANGE_ACTIVE_STEP:
      return {
        ...state,
        activeStep: action.payload,
        username: action.username ? action.username : state.username,
        error: false,
        errorMessage: "",
        errorType: "",
      };
    case loginType.SUCCESS_LOGIN:
      return { ...state, loading: false };
    case loginType.SET_LOGIN_TYPE:
      let payloadToNumber = parseInt(action.payload);
      return {
        ...state,
        typeLogin: payloadToNumber,
      };
    default:
      return { ...state };
  }
};

export default loginReducer;
